import styled from 'styled-components';
import { DefaultIcon } from 'styles/common';
import { Spinner, Input } from '@insly/qmt-reactjs-ui-lib';

export const InputStyled = styled(Input)`
  width: 100%;
    .qmt-ui-svg-icon {
        align-self: center;
    }
`;

export const SearchWrapper = styled.div`
  position: relative;
`;

export const Search = styled.div`
  display: flex; 
`;

export const CloseIcon = styled(DefaultIcon)`
  position: absolute;
  right: 46px;
  top: 20px;
  flex-shrink: 0;
`;

export const SpinnerStyled = styled(Spinner)`
  position: absolute;
  right: 46px;
  top: 20px;
  border-color: ${({ theme }) => theme.colors.primary}20;
  border-left-color: ${({ theme }) => theme.colors.primary};
`;

export const Drop = styled.ul<{ isDropShown: boolean }>`
  position: absolute;
  z-index: 1;
  top: calc(100% + 4px);
  right: 0;
  left: 0;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.borderHighlighted};
  border-radius: ${({ theme }) => theme.borderRadius};
  box-shadow: -6px 6px 0 rgba(148, 119, 90, 0.24);
  display: ${({ isDropShown }) => isDropShown ? 'block' : 'none'};
  overflow: hidden;
`;

export const ResultsItem = styled.li<{ noData?: boolean }>`
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 8px 16px;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #F0F0F0;
  }
`;

export const ResultsItemDataTitle = styled.div`
  ${({ theme }) => theme.text.normal};
`;

export const ResultsItemDataAdditional = styled.div`
  ${({ theme }) => theme.text.small};
  color: ${({ theme }) => theme.colors.subtle};
  margin-bottom: 2px;
  .highlight {
    color: ${({ theme }) => theme.colors.black};
  }
`;

export const ResultsItemErrorHeaderTitle = styled.div`
  font-family: ${({ theme }) => theme.font.bold};
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.primary};
`;

export const ResultsIcon = styled(DefaultIcon)<{ margin?: 'left' | 'right' }>`
  margin-right: ${({ margin }) => margin === 'right' ? '16px' : null};
  margin-left: ${({ margin }) => margin === 'left' ? '16px' : null};
`;

export const ResultsItemData = styled.div`
  flex: 1;
`;

